
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceinhinjewadi() {



  const cardData =
  {
    keyword: 'Taxi Service in Hinjewadi, Pune',
    heading: 'AB Ghule Cabs: Taxi Service in Hinjewadi, Pune',
    headingDescription: 'Planning to travel to or from Hinjewadi, Pune? AB Ghule Cabs offers reliable, comfortable, and affordable taxi services to meet your travel needs. Whether you are visiting for business, leisure, or a special event, our professional drivers and well-maintained vehicles ensure a smooth and stress-free journey. Let us make your trip to this bustling IT hub convenient and comfortable.',

    top: 'Top Places to Visit in Hinjewadi with AB Ghule Cabs',

        "topPlaces": [
          {
            title: "Rajiv Gandhi Infotech Park",
            description: "Hinjewadi is known for its sprawling IT parks, and Rajiv Gandhi Infotech Park is one of the most prominent. It houses numerous tech companies, offering a lively environment for professionals and entrepreneurs."
          },
          {
            title: "Morya Gosavi Ganpati Temple",
            description: "A revered religious site in Hinjewadi, the Morya Gosavi Ganpati Temple is dedicated to Lord Ganesha. It’s an important cultural and spiritual destination for locals and visitors alike."
          },
          {
            title: "Xion Mall",
            description: "Xion Mall in Hinjewadi is a popular shopping destination with various retail stores, restaurants, and entertainment options, perfect for a day out with friends or family."
          },
          {
            title: "Bhumkar Chowk",
            description: "A busy and well-known area in Hinjewadi, Bhumkar Chowk is surrounded by commercial complexes, hotels, and restaurants. It is a major junction for both locals and visitors."
          },
          {
            title: "Saras Baug",
            description: "Located nearby, Saras Baug is a lush green park perfect for family outings and picnics. The peaceful environment and historical temple make it a great spot for relaxation and leisure."
          },
          {
            title: "Mulshi Dam",
            description: "A short drive from Hinjewadi, Mulshi Dam is a picturesque location surrounded by natural beauty. It offers scenic views, making it ideal for day trips and photography."
          },
          {
            title: "Katraj Snake Park",
            description: "A well-known attraction near Hinjewadi, Katraj Snake Park is home to a variety of snakes and other reptiles. It’s an educational and thrilling experience for nature lovers."
          },
          {
            title: "E-Square Town Centre",
            description: "A popular entertainment destination in Hinjewadi, E-Square offers a multiplex, gaming zones, and a food court, making it a great place for family entertainment."
          },
          {
            title: "Pune-Okayama Friendship Garden",
            description: "A tranquil and beautiful Japanese-style garden located not far from Hinjewadi, this park is ideal for meditation, nature walks, and relaxation amidst lush greenery."
          },
          {
            title: "Sinhagad Fort",
            description: "A little farther out of Hinjewadi, Sinhagad Fort is a historic site offering spectacular views of Pune and its surroundings. A trek to the fort is both invigorating and rich in history, making it a great adventure for history enthusiasts and outdoor lovers."
          }
        ]
      ,


      services: [
        {
          "name": "Hinjewadi Taxi Service",
          description: "AB Ghule Cabs offers reliable taxi services in Hinjewadi, Pune. Our experienced drivers and well-maintained vehicles ensure a smooth and comfortable ride for your local or outstation travels. We guarantee timely and efficient service for every journey."
        },
        {
          "name": "Taxi Booking in Hinjewadi",
          description: "Book your taxi in Hinjewadi with AB Ghule Cabs. Our convenient and affordable taxi booking services allow you to enjoy a hassle-free journey, whether you're going for a local trip or traveling outside Pune. We ensure a seamless booking experience."
        },
        {
          "name": "Taxi in Hinjewadi Pune",
          description: "Looking for a taxi in Hinjewadi, Pune? AB Ghule Cabs provides comfortable and reliable taxis for your travel needs. Whether it's for business or leisure, our professional drivers guarantee a smooth ride with well-maintained vehicles."
        },
        {
          "name": "Cab Service in Hinjewadi",
          description: "AB Ghule Cabs offers trusted and efficient cab services in Hinjewadi. Our well-maintained vehicles and experienced drivers make every trip safe and comfortable, ensuring you travel hassle-free for both local and outstation destinations."
        },
        {
          "name": "Hinjewadi Cab Booking",
          description: "Book a cab in Hinjewadi with AB Ghule Cabs. We provide easy and quick booking options for local or outstation travel, ensuring you have a reliable ride at all times. Whether you need a ride for work or leisure, we're here to help."
        },
        {
          "name": "Reliable Taxi in Hinjewadi",
          description: "For a reliable taxi in Hinjewadi, AB Ghule Cabs is the best choice. We offer professional drivers, well-maintained vehicles, and timely services to ensure a comfortable and safe journey, whether for local or long-distance travel."
        },
        {
          "name": "Affordable Taxi in Hinjewadi",
          description: "AB Ghule Cabs offers affordable taxi services in Hinjewadi, Pune. Enjoy a comfortable and budget-friendly ride without compromising on quality or service. We provide reliable transport at competitive rates."
        },
        {
          "name": "24/7 Taxi Service in Hinjewadi",
          description: "Our 24/7 taxi service in Hinjewadi ensures that you always have access to a reliable taxi, no matter the time of day. Whether it's early morning or late at night, AB Ghule Cabs is available for your convenience, ensuring timely service round-the-clock."
        },
        {
          "name": "Luxury Taxi in Hinjewadi",
          description: "For those seeking luxury taxi services in Hinjewadi, AB Ghule Cabs offers premium vehicles with all the comforts you need for a sophisticated and enjoyable journey. Travel in style and comfort with our high-end taxis."
        },
        {
          "name": "Hinjewadi Cab Service",
          description: "AB Ghule Cabs provides efficient Hinjewadi cab services. Whether for business or leisure, our services are tailored to ensure your comfort and satisfaction throughout the ride. Enjoy a smooth, stress-free journey with our professional services."
        },
        {
          "name": "Taxi Service in Hinjewadi",
          description: "Book a taxi service in Hinjewadi with AB Ghule Cabs. Our services are designed to make your ride comfortable and hassle-free, with professional drivers ensuring your safety. We ensure a timely and efficient ride every time."
        },
        {
          "name": "Hinjewadi Cab Service Pune",
          description: "AB Ghule Cabs offers premium Hinjewadi cab services in Pune. From local rides to long-distance trips, we ensure you travel in comfort and style with well-maintained vehicles and skilled drivers. Enjoy smooth and safe rides with us."
        },
        {
          "name": "Hinjewadi Cab Service Pune Contact Number",
          description: "Need to contact us for a Hinjewadi cab service? Reach out to AB Ghule Cabs at our contact number for reliable and affordable taxi services in Pune. We're available to assist you with any booking or queries."
        },
        {
          "name": "Taxi Service in Hinjewadi Pune",
          description: "AB Ghule Cabs offers taxi services in Hinjewadi, Pune, with professional drivers and clean, well-maintained vehicles. Our service is designed for your convenience, ensuring a safe and smooth journey for local and outstation travel."
        },
        {
          "name": "Pune Airport to Hinjewadi Taxi Fare",
          description: "Book a taxi from Pune Airport to Hinjewadi with AB Ghule Cabs. We offer competitive and transparent pricing for a smooth and comfortable ride from the airport to Hinjewadi, ensuring an affordable and reliable journey."
        },
        {
          "name": "Cab Service in Hinjewadi Pune",
          description: "AB Ghule Cabs provides reliable and affordable cab services in Hinjewadi, Pune. Our fleet of vehicles and experienced drivers ensure that you travel in comfort and safety. Whether for business or leisure, we have the right vehicle for your needs."
        },
        {
          "name": "Cab Service in Pune for Outstation",
          description: "Looking for a cab service in Pune for an outstation trip? AB Ghule Cabs offers affordable and reliable outstation cab services from Pune, ensuring a comfortable ride wherever you're headed. Enjoy a smooth journey with our professional drivers."
        },
        {
          "name": "Monthly Taxi Service in Hinjewadi",
          description: "AB Ghule Cabs offers monthly taxi services in Hinjewadi for regular commuters or businesses. Our monthly packages are designed to provide reliable, convenient, and affordable travel solutions, ensuring consistent and hassle-free travel."
        },
        {
          "name": "Office Cab Service in Pune",
          description: "AB Ghule Cabs provides office cab services in Pune, offering a professional and reliable transport solution for employees. Our vehicles are well-maintained, ensuring a comfortable ride to and from your workplace every day."
        },
        {
          "name": "Cab Service in Hinjewadi Phase 3",
          description: "AB Ghule Cabs offers efficient cab services in Hinjewadi Phase 3. Whether it's for local travel or an outstation trip, we ensure that your ride is comfortable and hassle-free, with timely services and professional drivers."
        },
        {
          "name": "Tempo Traveller on Rent in Hinjewadi",
          description: "For larger groups, AB Ghule Cabs offers Tempo Traveller rentals in Hinjewadi. Our well-maintained vehicles ensure a comfortable and safe journey for group travel. Whether for a tour, family outing, or event, our Tempo Travellers are perfect for your needs."
        },
        {
          "name": "Mini Bus on Rent in Hinjewadi",
          description: "AB Ghule Cabs provides Mini Bus on rent in Hinjewadi for corporate events, weddings, or group tours. Our mini buses are spacious, comfortable, and well-maintained for your convenience, ensuring a pleasant and stress-free journey."
        },
        {
          "name": "Hinjewadi to Mumbai Cab",
          description: "Travel from Hinjewadi to Mumbai with AB Ghule Cabs. Our reliable cab service ensures a comfortable and smooth journey for your one-way or round-trip travel. Our professional drivers and well-maintained vehicles guarantee a hassle-free experience."
        },
        {
          "name": "Hinjewadi to Mumbai Airport Cab",
          description: "Book a cab from Hinjewadi to Mumbai Airport with AB Ghule Cabs. Our affordable and professional services ensure that you get to the airport on time, with a comfortable ride. We provide reliable and timely transport to and from the airport."
        },
        {
          "name": "Taxi Service in Hinjewadi Pune Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Taxi Service in Hinjewadi Pune. We ensure a smooth and enjoyable ride for all our customers. Whether you're booking a local trip or an outstation ride, we're always ready to assist."
        }
      ],

      tableData: [
        ["Hinjewadi Taxi Service", "-Taxi Booking Hinjewadi"],
        ["Taxi in Hinjewadi Pune", "-Cab service Hinjewadi"],
        ["Hinjewadi cab booking", "-Reliable taxi Hinjewadi"],
        ["Affordable taxi Hinjewadi", "-24/7 taxi service Hinjewadi"],
        ["Luxury taxi Hinjewadi", "-Hinjewadi cab service"],
        ["Taxi service in Hinjewadi", "-Hinjewadi cab service Pune"],
        ["Hinjewadi cab service Pune contact number", "-Taxi service in Hinjewadi Pune"],
        ["Pune airport to Hinjewadi taxi fare", "-Cab service in Hinjewadi Pune"],
        ["Cab service in Pune for outstation", "-Monthly taxi service in Hinjewadi"],
        ["Office cab service in Pune", "-Cab service in Hinjewadi Phase 3"],
        ["Tempo traveller on rent in Hinjewadi", "-Mini bus on rent in Hinjewadi"],
        ["Hinjewadi to Mumbai cab", "-Hinjewadi to Mumbai airport cab"]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Reliable and Professional Service",
          WhyChoosedescription: "AB Ghule Cabs provides reliable and professional taxi services in Hinjewadi, Pune. Our drivers are highly trained, courteous, and committed to ensuring a safe and comfortable ride for all passengers."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "We understand that travel needs can arise at any time. That’s why our taxi services are available 24/7. Whether it’s an early morning ride or a late-night journey, we’re always ready to assist you with your booking."
        },
        {
          WhyChooseheading: "Affordable Rates",
          WhyChoosedescription: "Our pricing is transparent and competitive, with no hidden charges. Whether you’re traveling for business, leisure, or group outings, we offer affordable taxi services to fit your budget."
        },
        {
          WhyChooseheading: "Clean and Well-Maintained Fleet",
          WhyChoosedescription: "Our fleet is made up of clean, well-maintained vehicles that are regularly checked for safety and comfort. We provide a variety of options, from economical sedans to more luxurious vehicles, to ensure your trip is a pleasant one."
        },
        {
          WhyChooseheading: "Safe and Comfortable Rides",
          WhyChoosedescription: "Safety is our priority. All our drivers are background-checked, and our vehicles are equipped with modern safety features, including GPS, to ensure you have a secure and smooth journey across Pune."
        },
        {
          WhyChooseheading: "Easy Booking Process",
          WhyChoosedescription: "Booking a taxi with AB Ghule Cabs is simple and convenient. You can book through our website, mobile app, or call our customer service team directly for instant assistance."
        },
        {
          WhyChooseheading: "Customer Satisfaction",
          WhyChoosedescription: "Customer satisfaction is at the heart of everything we do. With numerous positive reviews and loyal customers, we strive to provide an excellent travel experience every time you choose AB Ghule Cabs."
        }
      ]
      
  

  }

  const faqData = [
    {
        id: 'FAQ1',
        question: 'How can I book a taxi in Hinjewadi with AB Ghule Cabs?',
        answer: 'You can easily book a taxi by visiting our website, using our mobile app, or calling our customer service team for immediate assistance.',
      },
      {
        id: 'FAQ2',
        question: 'Are your drivers experienced and trustworthy?',
        answer: 'Yes, all our drivers are well-trained, experienced, and background-checked to ensure you receive the safest and most professional service.',
      },
      {
        id: 'FAQ3',
        question: 'What types of vehicles are available for booking?',
        answer: 'We offer a wide range of vehicles including sedans, SUVs, and luxury cars, so you can choose the perfect one based on your needs and preferences.',
      },
      {
        id: 'FAQ4',
        question: 'How do I pay for my ride?',
        answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments through our mobile app, for your convenience.',
      },
      {
        id: 'FAQ5',
        question: 'Are there any additional charges for waiting or detours?',
        answer: 'There may be additional charges for waiting time or detours, but we ensure full transparency. Any extra charges will be clearly communicated to you in advance.',
      },
      {
        id: 'FAQ6',
        question: 'Can I cancel or modify my booking?',
        answer: 'Yes, you can easily modify or cancel your booking through our website or app. If you need assistance, feel free to contact our customer service team.',
      },
      {
        id: 'FAQ7',
        question: 'Do you offer one-way and round-trip services?',
        answer: 'Yes, we provide both one-way and round-trip taxi services in and around Hinjewadi, Pune, allowing you to choose what works best for your travel needs.',
      },
      {
        id: 'FAQ8',
        question: 'Is AB Ghule Cabs available for group travel?',
        answer: 'Yes, we offer spacious vehicles suitable for group travel, ensuring that your friends, family, or colleagues can travel comfortably together.',
      },
      {
        id: 'FAQ9',
        question: 'What makes AB Ghule Cabs different from other taxi services?',
        answer: 'AB Ghule Cabs is distinguished by its commitment to customer satisfaction, professional drivers, affordable pricing, and a wide variety of vehicles. We focus on providing a seamless, safe, and comfortable experience for every traveler.',
      },
    ];
  const testimonials = [
    {
        id: 1,
        name: 'Mr. Siddharth Rao',
        feedback: 'I frequently travel to Hinjewadi for work, and AB Ghule Cabs has always been reliable. The drivers are professional, the cars are clean, and the rates are very reasonable. Highly recommended for business trips!',
        rating: 5,
      },
      {
        id: 2,
        name: 'Ms. Priya Verma',
        feedback: 'AB Ghule Cabs made my commute to Hinjewadi so much easier. Booking was quick, and the driver was friendly and punctual. I’ll definitely use their service again.',
        rating: 5,
      },
    ];
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Taxi Service in Hinjewadi Pune | Reliable & Affordable Cabs</title>
  <meta name="description" content="Book reliable and affordable taxi service in Hinjewadi Pune with AB Ghule Cabs. 24/7 taxi service for local and outstation trips. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Hinjewadi Taxi Service, Taxi Booking Hinjewadi, Taxi in Hinjewadi Pune, Cab service Hinjewadi, Hinjewadi cab booking, Reliable taxi Hinjewadi, Affordable taxi Hinjewadi, 24/7 taxi service Hinjewadi, Luxury taxi Hinjewadi, hinjewadi cab service, Taxi service in hinjewadi, Hinjewadi cab service pune, Hinjewadi cab service pune contact number, taxi service in hinjewadi pune, pune airport to hinjewadi taxi fare, cab service in hinjewadi pune, cab service in pune for outstation, monthly taxi service in hinjewadi, office cab service in pune, cab service in hinjewadi phase 3, tempo traveller on rent in hinjewadi, mini bus on rent in hinjewadi, hinjewadi to mumbai cab, hinjewadi to mumbai airport cab" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Taxi Service in Hinjewadi Pune | Reliable & Affordable Cabs" />
  <meta property="og:description" content="Book reliable and affordable taxi service in Hinjewadi Pune with AB Ghule Cabs. 24/7 taxi service for local and outstation trips. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/taxi-service-hinjewadi.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/taxi-service-hinjewadi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Taxi Service in Hinjewadi Pune",
        description: "Book reliable and affordable taxi service in Hinjewadi Pune with AB Ghule Cabs. 24/7 taxi service for local and outstation trips. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Hinjewadi, Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/taxi-service-hinjewadi",
        "logo": "https://abghulecabs.com/images/taxi-service-hinjewadi.jpg",
        "image": "https://abghulecabs.com/images/taxi-service-hinjewadi.jpg",
        "priceRange": "₹1000 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/taxi-service-hinjewadi",
          "priceCurrency": "INR",
          "price": "1000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "140"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi K"
            },
            "datePublished": "2024-11-10",
            "reviewBody": "Excellent service! The cab was on time, and the driver was polite. Highly recommend for office and outstation trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha S"
            },
            "datePublished": "2024-10-15",
            "reviewBody": "The best taxi service in Hinjewadi. Affordable rates and excellent customer support."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Hinjewadi and Surrounding Areas Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5941",
            "longitude": "73.7495"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/taxi-service-hinjewadi"
        },
        "keywords": "Hinjewadi Taxi Service, Taxi Booking Hinjewadi, Taxi in Hinjewadi Pune, Cab service Hinjewadi, Hinjewadi cab booking, Reliable taxi Hinjewadi, Affordable taxi Hinjewadi, 24/7 taxi service Hinjewadi, Luxury taxi Hinjewadi, hinjewadi cab service, Taxi service in hinjewadi, Hinjewadi cab service pune, Hinjewadi cab service pune contact number, taxi service in hinjewadi pune, pune airport to hinjewadi taxi fare, cab service in hinjewadi pune, cab service in pune for outstation, monthly taxi service in hinjewadi, office cab service in pune, cab service in hinjewadi phase 3, tempo traveller on rent in hinjewadi, mini bus on rent in hinjewadi, hinjewadi to mumbai cab, hinjewadi to mumbai airport cab"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/61.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Taxiserviceinhinjewadi;